import React from "react";

export function ParkCardSkeleton() {
  return (
    <div className="bg-white border border-border rounded-xl overflow-hidden" data-testid="park-card-skeleton">
      <div className="aspect-[16/10] skeleton-shimmer" />
      <div className="p-4 space-y-3">
        <div className="h-3 w-24 rounded skeleton-shimmer" />
        <div className="h-5 w-3/4 rounded skeleton-shimmer" />
        <div className="flex gap-2">
          <div className="h-4 w-4 rounded skeleton-shimmer" />
          <div className="h-4 w-4 rounded skeleton-shimmer" />
          <div className="h-4 w-4 rounded skeleton-shimmer" />
          <div className="h-4 w-4 rounded skeleton-shimmer" />
        </div>
        <div className="flex justify-between pt-2">
          <div className="h-6 w-20 rounded skeleton-shimmer" />
          <div className="h-8 w-24 rounded-full skeleton-shimmer" />
        </div>
      </div>
    </div>
  );
}

export function ParkCardSkeletonGrid({ count = 6 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
      {Array.from({ length: count }).map((_, i) => <ParkCardSkeleton key={i} />)}
    </div>
  );
}
